import React from 'react';
import { View, StyleSheet } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import Friends from '../../components/friends';
import theme from '../../constants/theme.style.js';

const styles = StyleSheet.create({
  icon: {
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
  },
  container: {
    width: '40vw',
    height: `calc(100vh - ${theme.WEB_NAV_HEIGHT}px)`,
    backgroundColor: 'transparent',
    borderColor: 'white',
    padding: theme.CONTAINER_MARGIN,
    overflow: 'hidden',
    shadowColor: theme.GREY_MEDIUM_COLOR,
    shadowRadius: 20,
    shadowOpacity: 1,
  },
  subHeader: {
    color: theme.GREEN_DARKER_COLOR,
    marginTop: theme.CONTAINER_MARGIN * 1.5,
    marginBottom: theme.CONTAINER_MARGIN,
    fontSize: theme.FONT_SIZE_HEADLINE,
    borderBottomColor: theme.PRIMARY_COLOR,
    borderBottomWidth: 1,
    marginLeft: theme.CONTAINER_MARGIN,
    marginRight: theme.CONTAINER_MARGIN,
    paddingBottom: theme.CONTAINER_MARGIN,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

const NewMessageFriendsSelection = () => (
  <View style={styles.container}>
    <CustomText style={styles.subHeader}>Choose A Friend</CustomText>
    <Friends selectFriend />
  </View>
);

export default NewMessageFriendsSelection;
